<template>
  <v-dialog v-model="showDialog" v-if="showDialog" :class="dialogClass" :attach="attach" persistent scrollable :max-width="maxWidth || 450" :width="setWidth" v-on:keydown.enter="defaultButtonAction">
    <v-card>
      <v-card-title :class="['py-3 font-weight-medium base-dialog__title', titleClass]">
        <v-icon v-if="showTitleIcon"
                :size="titleIconSize"
                class="mr-2"
                :color="iconColor || 'error'">
          {{ iconCode }}
        </v-icon>
        <span :class="[titleClass ? '': 'base-dialog-text__title', 'body-2']">
          {{ title }}
        </span>
        <v-spacer></v-spacer>
        <v-icon v-if="!hideClose" @click="cancel" :color="iconColor">close</v-icon>
      </v-card-title>
      <v-card-text :style="calculateStyle" class="base-dialog">
        <slot></slot>
      </v-card-text>
      <v-card-actions class="px-4 pt-0 pb-4 d-flex justify-end">
        <v-btn height="30px" v-if="!saveButtonOnly" rounded elevation="0" outlined :color="cancelButtonColor" @click="cancel" :width="cancelButtonWidth ? cancelButtonWidth : ''">
          {{ cancelButtonText }}
        </v-btn>
        <v-btn height="30px" v-if="!cancelButtonOnly" :loading='this.currentLoading' rounded elevation="0" :disabled="saveDisabled" :class="[saveButtonColor ? saveButtonColor : 'resGreen', 'white--text']" :width="saveButtonWidth ? saveButtonWidth : ''" @click="save">
          {{ saveButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    components: {
    },
    props: {
      showDialog: {},
      title: {},
      attach: {},
      titleClass: {},
      dialogClass: {},
      saveButtonText: {},
      saveButtonColor: {},
      saveButtonWidth: {},
      cancelButtonText: {},
      cancelButtonColor: {
        type: String,
        default: 'resRed base'
      },
      cancelButtonTextColor: {},
      cancelButtonWidth: {},
      defaultButtonAction: {
        type: Function
      },
      backgroundColor: {
        type: String,
        default: 'white'
      },
      maxWidth: {},
      hideActions: {},
      saveButtonOnly: {
        default: false
      },
      cancelButtonOnly: {
        default: false
      },
      showTitleIcon: {},
      iconTitle: {},
      iconColor: {},
      hideClose: {},
      extraLeftButton: {},
      extraLeftButtonText: {},
      saveDisabled: {},
      setWidth: {},
      setHeight: {},
      titleIconSize: {},
      ignorePadding: {},
    },
    data() {
      return {}
    },
    methods: {
      save() {    
        if (!this.saveDisabled && !this.currentLoading) {
          this.$emit('save', true);
        }
      },
      cancel() {
        this.$emit('cancel', true);
      }
    },
    computed: {
      ...mapGetters(['currentLoading']),
      iconCode() {
        if (this.iconTitle) {
          return this.iconTitle;
        }
        return 'warning';
      },
      calculateStyle() {
        return "height:" + this.setHeight + "px;" +
          "background-color:" + this.backgroundColor + ";"
      }
    }
  }
</script>

<style lang="scss" scoped>
    .base-dialog {
    color: var(--v-resGrey-darken2) !important;
    padding: 0px 20px !important;
  }

  .base-dialog__title {
      padding: 12px 20px !important;
      line-height: normal;
      height: 40px;
  }

  .base-dialog-text__title {
    font-size: 15px;
    color: #7a7a7a;
  }

  .v-icon {
      font-size: 14px;
  }

  .override {
    background-color: #03739c;
    color: white;
  }

  .delete-warning {
    background-color: #d0021b !important;
    color: white;
  }
</style>
